import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { getProductDetailsAction } from './select-product.actions';
import { ISelectProductFeature } from './select-product.feature.state';
import { getFailures, getIsLoading } from './select-product.selectors';

@Injectable()
export class SelectProductFacade {
  public isLoading$ = this.store.select(getIsLoading);
  public failures$ = this.store.select(getFailures);

  constructor(private store: Store<ISelectProductFeature>) {}

  public getProductDetails(barcode: string): void {
    this.store.dispatch(getProductDetailsAction({ barcode }));
  }
}
